import type { IconName } from './Icon'

/**
 * The three things the ＋ button can do, defined ONCE.
 *
 * Two surfaces read this list: the launchpad card at the foot of the rail, which
 * promises them in full sentences, and the ＋ sheet's tab strip, which performs them
 * under one-word labels. They share the KEY, the ICON and the COLOUR — the parts that
 * make "the green ＋ thing" on the card and in the sheet recognisably the same thing —
 * and keep their own wording, because a tab is a label and a card is an explanation
 * (owner, 2026-08-18: 我要的只是加入 icon 並沒有要你把文字也換上去).
 *
 * `key` is the ＋ sheet's tab id, which is why the order is the tab order.
 */
export type LaunchpadKey = 'agent' | 'project' | 'humans'

export const LAUNCHPAD_TILES: {
  key: LaunchpadKey
  icon: IconName
  /** Palette token: `.lp-<colour>` fills the card's chip, `.lp-ink-<colour>` inks the
   *  tab's icon. One token so the two surfaces cannot disagree about which is which. */
  color: 'green' | 'mauve' | 'blue'
  /** The ＋ sheet's tab label. */
  label: string
  /** The card's headline for the same thing. */
  title: string
  sub: string
}[] = [
  {
    key: 'agent',
    icon: 'add',
    color: 'green',
    label: 'Agent',
    title: 'Pair a machine & create an agent',
    sub: 'Bring a computer online.',
  },
  {
    key: 'project',
    icon: 'chat',
    color: 'mauve',
    label: 'Project',
    title: 'Create project chat',
    /*
     * "Start a new teammate." in avg-design's card, and wrong: this creates a ROOM,
     * not an agent — that is the tile above.
     */
    sub: 'A room for people and agents.',
  },
  {
    key: 'humans',
    icon: 'group',
    color: 'blue',
    label: 'Humans',
    title: 'Connect people and their Agents',
    sub: 'Search and connect.',
  },
]
